import React from 'react'

import {
  StyleSheet,
  View,
} from 'react-native';
import Messenger from '../components/communication/Messenger';

interface Props {
}

const MessengerScreen: React.FC<Props> = ({ 
}) => {   
  return ( 
    <View style={styles.container}>
      <Messenger />
    </View>
  )
};

const styles = StyleSheet.create({
  container: {
    alignSelf: 'center',
    flex: 1,
    width: "100%"
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 20
  }
});

export default MessengerScreen